<template lang="pug">
  #wt-stat-column
    .is-flex.is-align-items-center
      .level-left.mr-3
        WtSvgIcon(:icon="icon" :width="iconWidth" :height="iconHeight").padding-right
      .level-right.is-flex-direction-column.is-align-items-flex-start
        .stat-name {{ name }}
        .has-text-black.has-font-weight-normal.is-size-6.stat-value {{ value }}
</template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "WtStatColumn",

  components: {
    WtSvgIcon
  },

  props: {
    icon: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    value: {
      type: String,
      required: true
    },

    iconWidth: {
      type: String,
      default: "48px"
    },
    iconHeight: {
      type: String,
      default: "48px"
    }
  }
};
</script>

<style lang="sass" scoped>
#wt-stat-column
  .level-left
    flex-shrink: 1
  .level-padding
    padding: 7px 0
  .stat-name
    font-family: Manrope
    font-size: 14px
    font-weight: 400
    line-height: 20px
    color: #5A5C60 !important
  .stat-value
    font-family: Manrope
    line-height: 24px
</style>
